interface CreatedAtSortable {
  createdAt: string | Date;
  id?: string | number;
}

const getCreatedAtTimestamp = (value: string | Date): number => {
  const timestamp = value instanceof Date ? value.getTime() : Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : 0;
};

export const compareCreatedAtDesc = <TItem extends CreatedAtSortable>(
  left: TItem,
  right: TItem
): number => {
  const timestampComparison =
    getCreatedAtTimestamp(right.createdAt) -
    getCreatedAtTimestamp(left.createdAt);

  if (timestampComparison !== 0) {
    return timestampComparison;
  }

  return String(left.id ?? '').localeCompare(String(right.id ?? ''));
};

export const sortByCreatedAtDesc = <TItem extends CreatedAtSortable>(
  items: readonly TItem[]
): TItem[] => [...items].sort(compareCreatedAtDesc);
